import React from 'react';
import { Card } from '../ui/Card';
import { SimilarityBadge } from '../similarity/SimilarityBadge';
import type { MCQ } from '../../types/mcq';

interface MCQMatchCardProps {
  match: MCQ;
  isExpanded: boolean;
  isEditing: boolean;
  onToggleExpand: (id: number) => void;
  children?: React.ReactNode;
}

export function MCQMatchCard({ 
  match, 
  isExpanded, 
  isEditing, 
  onToggleExpand,
  children 
}: MCQMatchCardProps) {
  return (
    <Card 
      className="overflow-hidden hover:shadow-md transition-shadow duration-200 cursor-pointer"
      onClick={() => {
        if (!isEditing) {
          onToggleExpand(match.id);
        }
      }}
    >
      <div className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-8">
          <div className="flex flex-wrap items-center gap-3">
            <SimilarityBadge score={match.similarityScore || 0} />
            <span className="text-sm text-gray-600">
              MCQID: {match.mcqId}
            </span>
          </div>
        </div>
        {children}
      </div>
    </Card>
  );
}